<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.9)"
  size="medium"
  color="#fff"
  type="line-scale-pulse-out"
  [fullScreen]="true"
  ><p style="color: white">{{ 'loading-label' | translate }}</p></ngx-spinner
>
<h1>Search Results</h1>
<hr class="titles_page--hr mb-4" />
<section class="container titles_page">
  <div class="table__container table_responsive">
    <span class="d-inline-block mb-2">{{ pageInfo }}</span>
    <dx-data-grid
      [dataSource]="searchResults"
      [showColumnLines]="false"
      [showColumnHeaders]="false"
      [wordWrapEnabled]="true"
      [showRowLines]="true"
      [showBorders]="true"
      class="gah-datagrid"
      (onRowClick)="onSelectionChange($event)"
      [noDataText]="'No Data Found'"
      (onContentReady)="onContentReady($event)"
    >
      <dxo-load-panel [enabled]="false"></dxo-load-panel>
      <dxo-paging [pageSize]="10"> </dxo-paging>
      <dxo-pager
        [visible]="true"
        [allowedPageSizes]="[5, 10, 25, 'all']"
        [displayMode]="'compact'"
        [showPageSizeSelector]="true"
        [showInfo]="true"
        infoText="Displaying {0} - {1} of {2} "
        [showNavigationButtons]="true"
      ></dxo-pager>

      <dxo-scrolling [useNative]="true" columnRenderingMode="virtual"> </dxo-scrolling>

      <dxi-column
        dataField="thumbnail_url"
        caption="thumbnailUrl"
        [allowFiltering]="false"
        [allowSorting]="false"
        [allowExporting]="false"
        [visible]="true"
        cellTemplate="cellTemplate"
      ></dxi-column>
      <div *dxTemplate="let source of 'cellTemplate'" class="custom-search-template">
        <div class="d-flex">
          <div class="px-2 mx-2">
            <img
              *ngIf="source.data?.thumbnail_url"
              [src]="source.data?.thumbnail_url"
              width="100"
              height="100"
              alt=""
              class="img-fluid"
            />

            <img
              *ngIf="!source.data?.thumbnail_url"
              [src]="'assets/img/default_poster_small.jpg'"
              width="100"
              height="100"
              alt=""
              class="img-fluid"
            />
          </div>
          <div class="px-2">
            <span class="badge bg-dark" [textContent]="source.data?.type"></span>
            <div class="my-3 text-break" [textContent]="source.data?.name"></div>
            <div class="d-flex my-3" *ngIf="source.data?.local_title_release_title_name">
              <!-- *ngIf="source.data?.local_title_release_title_name" -->
              <div class="fw-bold mr-3 local-title">Local Title</div>
              <div
                class="text-break"
                [textContent]="source.data?.local_title_release_title_name"
              ></div>
            </div>
            <div class="d-flex my-3" *ngIf="source.data?.asset_category">
              <div class="fw-bold mr-3 local-title">Categories</div>
              <div class="text-break" [textContent]="source.data?.asset_category"></div>
            </div>
          </div>
        </div>
      </div>
      <dxo-toolbar>
        <dxi-item location="before">
          <h3>Showing results for "{{ searchValue }}"</h3>
        </dxi-item>
      </dxo-toolbar>
    </dx-data-grid>
  </div>
</section>
